export const TrainIcon = ({ color = "#DBBE78", size = 16, ...props }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M6 0C3 0 0 0.368421 0 2.94737V9.94737C0 11.3695 1.1775 12.5263 2.625 12.5263L1.5 13.6316V14H3.1725L4.6725 12.5263H7.5L9 14H10.5V13.6316L9.375 12.5263C10.8225 12.5263 12 11.3695 12 9.94737V2.94737C12 0.368421 9.315 0 6 0ZM2.625 11.0526C2.0025 11.0526 1.5 10.5589 1.5 9.94737C1.5 9.33579 2.0025 8.8421 2.625 8.8421C3.2475 8.8421 3.75 9.33579 3.75 9.94737C3.75 10.5589 3.2475 11.0526 2.625 11.0526ZM5.25 5.89474H1.5V2.94737H5.25V5.89474ZM6.75 5.89474V2.94737H10.5V5.89474H6.75ZM9.375 11.0526C8.7525 11.0526 8.25 10.5589 8.25 9.94737C8.25 9.33579 8.7525 8.8421 9.375 8.8421C9.9975 8.8421 10.5 9.33579 10.5 9.94737C10.5 10.5589 9.9975 11.0526 9.375 11.0526Z"
            fill={color}
        />
    </svg>
);
